import '../../stylesheets/dashboards/dashboards.css'
import '../../stylesheets/dashboards/transaction-comps.css'
import '../../stylesheets/skeletons/paywallblock.css'
import { useState, useEffect, useRef } from 'react'
import { useSubscription } from "../../hooks/external/proprietary/handlers/useSubscription.js"

const PaywallBlock = () => {
    const { handleFetchCheckoutSessionURL } = useSubscription()

    //stateful vars
    const [isLoading, setIsLoading] = useState(false)
    const PLACEHOLDER_TILES = [
        'EV', 'Market Cap', 'Revenue Growth', 'Revenue Multiple',
        'EBITDA Margin', 'EBITDA Multiple', 'Earnings Growth', 'Earnings Multiple',
        'Rule of 40',
    ]

    // logic
    const fetchStipeCheckoutSessionURL = async () => {
        try {
            setIsLoading(true)
            const url              = await handleFetchCheckoutSessionURL()
            console.log("[SUCCESS] STRIPE CHECKOUT SESSION URL: ", url)
            window.location.href   = url 

        } catch (error) {
            console.error('✗ [ERROR] fetching stripe checkout session url:', error.message)
            // need below conditional shape in eror block because if request never reaches backend there is no response on the error object!
                // and therefore dot notationing into a prop that is undefined as you know is a syntax error and will break our app!
                // so need the soft guard in the conditional + the conditional wrapper around the error.response.status logic portion 
            if (error.response?.status) console.error('✗ [STATUS]:', error.response.status)
        }
    }

    // rendered jsx
    return (
        <div className="page-wrapper">
            <div className="dashboard">

                {/* Left Panel — decorative tiles */}
                <div className="left-panel">
                    <div className="left-panel-header-container">
                        <h2 className="panel-title">Metrics</h2>
                    </div>

                    <div className="component-tray-container">
                        <div className="component-tray">
                            <div className="component-tray-text">Drop metric 1 here</div>
                        </div>
                        <div className="component-tray">
                            <div className="component-tray-text">Drop metric 2 here</div>
                        </div>
                    </div>

                    <div className="transaction-tiles-container">
                        <div className="tiles-grid">
                            {PLACEHOLDER_TILES.map(name => (
                                <div className="paywall-tile-placeholder" key={name}>
                                    {name}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Right Panel — empty chart areas */}
                <div className="right-panel">
                    <div className="right-panel-header-container">
                        <h2 className="panel-title">Profiles</h2>
                        <button className="selector-btn">
                            <svg className="edit-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                <path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                            </svg>
                            Edit Selection
                        </button>
                    </div>

                    <div className="charts-container">
                        <div className="chart-section">
                            <div className="empty-state">Metric tile 1 from palette charted here</div>
                        </div>
                        <div className="chart-section">
                            <div className="empty-state">Metric tile 2 from palette charted here</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Full-viewport modal overlay */}
            <div className="paywall-backdrop">
                <div className="paywall-card">
                    <h2>Upgrade to Continue!</h2>
                    <p>
                        You've reached the limit of the free tier.
                    </p>
                    <p>
                        Quickly checkout with Stripe to unlock unlimited usage access to dashboards, metrics, and analytics!
                    </p>
                    <button
                        className="paywall-subscribe-btn"
                        onClick={fetchStipeCheckoutSessionURL}
                        disabled={isLoading}
                    >
                        {isLoading
                            ? <span className="paywall-spinner" />
                            : 'Subscribe Now'
                        }
                    </button>
                </div>
            </div>
        </div>
    )
}

export default PaywallBlock
